import Header from './component/header/Header';
import { AppProvider } from './context/AppContext';
import { MapProvider } from './context/MapContext';
import Notice from './component/modal/Notice';
import CentralityIndex from './component/modal/CentralityIndex';
import PartitionWrapper from './component/content/PartitionWrapper';
import axios from 'axios';
import { useEffect } from 'react';

function createVisitorLog() {
	axios({
		method: 'GET',
		url:
			process.env.REACT_APP_CONTEXT_PATH +
			'/interactive/api/visitor/log.json?item_cd=cen',
	});
}

function App() {
	useEffect(() => {
		createVisitorLog();
	}, []);

	return (
		<AppProvider>
			<MapProvider>
				<Header />
				<Notice />
				<CentralityIndex />
				<PartitionWrapper />
			</MapProvider>
		</AppProvider>
	);
}

export default App;
